import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { of as observableOf } from 'rxjs';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class MainServiceService {

  constructor(
    private _http: HttpClient,

  ) {

  }

  private apiHost = window['__env'].apiCueUrl;//environment.backEndUri

  public getProvincias(): Observable<any> {
    let auxEndpoint = this.apiHost + '/catalogos/v1/padroncue/jurisdicciones';
    return this._http.get(auxEndpoint);
  }

  public getPartidos(jurisdiccion: string): Observable<any> {
    let auxEndpoint = this.apiHost + '/catalogos/v1/padroncue/jurisdiccion/' + jurisdiccion + '/departamentos'
    return this._http.get(auxEndpoint);
  }

  public getLocalidades(jurisdiccion: string, departamento: string): Observable<any> {
    let auxEndpoint = this.apiHost + '/catalogos/v1/padroncue/jurisdiccion/' + jurisdiccion + '/departamento/' + departamento + '/localidades';
    return this._http.get(auxEndpoint);
  }

  public getEscuelas(jurisdiccion: string, departamento: string, localidad: string): Observable<any> {
    let auxEndpoint = this.apiHost + '/catalogos/v1/padroncue/jurisdiccion/' + jurisdiccion +
      '/departamento/' + departamento +
      '/localidad/' + localidad + '/establecimientos'
    return this._http.get(auxEndpoint);
  }

}
